import Cookies from 'js-cookie';

export function setCookie(key: string, value: string) {
  Cookies.set(`${process.env.NODE_ENV}-${key}`, value, {
    expires: 1,
    domain: 'linshimuye.com',
  });
}

export function getCookie(key: string) {
  return Cookies.get(`${process.env.NODE_ENV}-${key}`);
}

export function getOATokenCookie() {
  return Cookies.get(process.env.VUE_APP_OA_TOP_COOKIE_NAME);
}

export function checkCookie(): boolean {
  const cookieEnabledKey = 'cookieEnabled';
  Cookies.set(`${process.env.NODE_ENV}-${cookieEnabledKey}`, '1', {
    expires: 1,
  });
  const cookieEnabled = Cookies.get(cookieEnabledKey);
  if (cookieEnabled) {
    Cookies.remove(`${process.env.NODE_ENV}-${cookieEnabledKey}`);
    return true;
  } else {
    return false;
  }
}
export function removeCookie(key: string) {
  Cookies.remove(`${process.env.NODE_ENV}-${key}`, {
    domain: 'linshimuye.com',
  });
}

export function removeOATokenCookie() {
  Cookies.remove(process.env.VUE_APP_OA_TOP_COOKIE_NAME, {
    domain: 'linshimuye.com',
  });
}
